// extracted by mini-css-extract-plugin
module.exports = {"root":"_6Rl3v7qNXGa0xjIv18Biu","header":"_2Avmhi1zla0ZdU8xfVOtnN","underLine":"GTjmKmMRVz5Xu4ak2iZAN","content":"_3MeVIoQZZ10gDp9y6e_YNv","secondary":"_24g9Xy_9rSvVgDd0b8wowl"};